import axios from 'axios';

const BACKEND = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND}/api`;

const client = axios.create({ baseURL: API, withCredentials: true });

client.interceptors.request.use((cfg) => {
  const token = localStorage.getItem('c24_token');
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

export const api = {
  // auth
  signup: (data) => client.post('/auth/signup', data).then((r) => r.data),
  login: (data) => client.post('/auth/login', data).then((r) => r.data),
  me: () => client.get('/auth/me').then((r) => r.data),
  logout: () => client.post('/auth/logout').then((r) => r.data),
  googleSession: (sessionId) => client.post('/auth/google/session', {}, { headers: { 'X-Session-ID': sessionId } }).then((r) => r.data),

  // catalog
  categories: () => client.get('/categories').then((r) => r.data),
  servicesByCategory: (id) => client.get(`/services/${id}`).then((r) => r.data),
  offers: () => client.get('/offers').then((r) => r.data),

  // bookings
  createBooking: (data) => client.post('/bookings', data).then((r) => r.data),
  myBookings: () => client.get('/bookings').then((r) => r.data),

  // admin
  adminStats: () => client.get('/admin/stats').then((r) => r.data),
  adminBookings: () => client.get('/admin/bookings').then((r) => r.data),
  adminUsers: () => client.get('/admin/users').then((r) => r.data),
  upsertCategory: (c) => client.post('/admin/categories', c).then((r) => r.data),
  deleteCategory: (id) => client.delete(`/admin/categories/${id}`).then((r) => r.data),
  upsertService: (s) => client.post('/admin/services', s).then((r) => r.data),
  deleteService: (id) => client.delete(`/admin/services/${id}`).then((r) => r.data),
  upsertOffer: (o) => client.post('/admin/offers', o).then((r) => r.data),
  deleteOffer: (id) => client.delete(`/admin/offers/${id}`).then((r) => r.data),
};

export const setToken = (t) => t ? localStorage.setItem('c24_token', t) : localStorage.removeItem('c24_token');
export const getToken = () => localStorage.getItem('c24_token');

export default api;
